// base
import { createRoot } from 'react-dom/client';

// App
import App from './App.js';

//styles
import './assets/scss/index.scss';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-coverflow';
import { themeOptions } from 'styles';

// contexts
import { AlertProvider } from 'contexts';

// providers
import { AlarmProvider, LoadingProvider, PkgProvider } from './providers';

// components
import { GlobalStyles } from 'components';

// modules
import { saga } from './modules/rootReducer.js';
import { history, persistor, sagaMiddleware, store } from './modules/store.js';

// libraries
import { RecoilRoot } from 'recoil';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@mui/material/styles';
import { ConnectedRouter } from 'connected-react-router';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { PersistGate } from 'redux-persist/integration/react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// dayjs
import 'dayjs/locale/ko';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

sagaMiddleware.run(saga);
dayjs.locale('en');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Riyadh');

const rootElement = document.getElementById('root');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      retryOnMount: true,
      refetchOnReconnect: false,
      staleTime: 0,
      throwOnError: false
    },
    mutations: {
      retry: false,
      throwOnError: false,
      onError: (error) => {
        console.log('== Mutation Error == : ', `${error.message}`);
      }
    }
  }
});

if (rootElement) {
  createRoot(rootElement).render(
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <HelmetProvider>
          <Provider store={store}>
            <PersistGate persistor={persistor}>
              <ConnectedRouter history={history}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <CookiesProvider>
                    <PkgProvider>
                      <ThemeProvider theme={themeOptions}>
                        <LoadingProvider>
                          <AlarmProvider>
                            <AlertProvider>
                              <GlobalStyles />
                              <ReactQueryDevtools initialIsOpen={false} />

                              <App />
                            </AlertProvider>
                          </AlarmProvider>
                        </LoadingProvider>
                      </ThemeProvider>
                    </PkgProvider>
                  </CookiesProvider>
                </LocalizationProvider>
              </ConnectedRouter>
            </PersistGate>
          </Provider>
        </HelmetProvider>
      </RecoilRoot>
    </QueryClientProvider>
  );
}
